import FavouriteTemplates from "./FavouriteTemplatesStateContainer";

export default FavouriteTemplates;
